import { forwardRef } from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import {
  type TTabsContentElement,
  type TTabsContentProps,
} from "@/ui/components/navigation/Tabs/Tabs.config";
import { cn } from "@/ui/lib/utils";

export const TabsContent = forwardRef<TTabsContentElement, TTabsContentProps>(
  (
    {
      className,
      ...props
    },
    ref,
  ) => (
    <TabsPrimitive.Content
      data-component="TabsContent"
      ref={ref}
      className={cn(
        "px-1 py-2",
        className,
      )}
      {...props}
    />
  ),
);

TabsContent.displayName = TabsPrimitive.Content.displayName;
